import React from 'react';
import './terms.css';
import { Button } from '@salesforce/design-system-react';
import { useNavigate } from 'react-router-dom';

const TermsAndConditions = () => {
  const navigate = useNavigate();

  const navigateBack = (e) => {
    e.stopPropagation();
    navigate('/login');
  };

  return (
    <div className="mx-auto max-w-7xl px-6 py-24">
      <div>
        <div className="slds-grid slds-wrap">
          <h1 className="block mx-auto">Terms & Conditions</h1>
        </div>
        <div className="slds-grid slds-wrap">
          <Button className="mx-auto" label="Back" onClick={(e) => navigateBack(e)} />
        </div>
        <div className="mb-8 mt-4">
          <div className="">
            <h5>1. DEFINITIONS</h5>
            <p>
              The following terms, when used in these Subscription Terms (hereafter, this
              “Agreement”) will have the following meanings:
            </p>
            <p>
              1.1. “Order Form” means a Syndica order form, online order page or other similar
              document that sets forth the components of the Syndica Platform to which Customer
              (defined below) is obtaining a subscription, applicable subscription term, pricing
              therefor and other relevant terms, and that references this Agreement. 1.2. “Platform”
              means Syndica’s developer tooling and infrastructure software for blockchain-based
              distributed applications, together with associated software and documentation provided
              by Syndica. 1.3. “Proprietary Information” means any information or data disclosed or
              made available by either party (the “Disclosing Party”) to the other party (the
              “Receiving Party”) that is marked or otherwise designated as confidential or
              proprietary or that should otherwise be reasonably understood to be confidential in
              light of the nature of the information and the circumstances surrounding disclosure.
              Proprietary Information of Syndica includes, without limitation, all software,
              documentation and other non-public information relating to the Platform or the
              features, functionality and performance thereof. 1.4. “Term” shall mean Customer’s
              initial subscription term for the Platform as set forth in the applicable Order Form
              along with any applicable subscription renewal terms, as described in Section 6 below.
            </p>
          </div>

          <div className="mt-4">
            <h5>2. PLATFORM AND SUPPORT</h5>
            <p>
              2.1. General. Syndica Inc. (“Syndica”) provides its Platform to you (“Customer”)
              pursuant to the terms of this Agreement. By entering into a Platform Order Form with
              Syndica or otherwise registering for, accessing or using the Platform, Customer
              unconditionally accepts and agrees to all of the terms of this Agreement. By entering
              into this Agreement on behalf of a company or other legal entity, Customer represents
              that it has the authority to bind such entity and its affiliates to the terms of this
              Agreement, and, accordingly, the terms "Customer" shall refer to such entity and its
              affiliates. If Customer does not have such authority, or Customer does not agree to
              all of the terms of this Agreement, Customer may not use the Platform. Capitalized
              terms not defined herein shall be given the meaning set forth in the applicable Order
              Form. 2.2. Platform Services. Syndica will use commercially reasonable efforts to
              provide Customer the Platform during the Term solely for Customer’s internal business
              operations, subject to any terms and restrictions set forth in this Agreement and each
              Order Form. 2.3. Support. Subject to the terms of this Agreement and the applicable
              Order Form (and payment of all applicable fees), Syndica will provide customer
              reasonable technical support in accordance with its standard practice. 2.4. Agreement
              Updates. Syndica reserves the right to change or modify portions of this Agreement at
              any time. If Syndica does so, it will post the changes on this page and will indicate
              at the top of this page the date this Agreement was last revised. Syndica will also
              notify Customer, either through the Platform user interface, in an email notification
              or through other reasonable means. Any such changes will become effective no earlier
              than fourteen (14) days after being posted, except that changes addressing new
              functions of the Platform or changes made for legal reasons may become effective
              immediately. Customer’s continued use of the Platform after the date any such changes
              become effective constitutes acceptance of the new Agreement. 2.5. Beta Platform and
              Products. From time to time, Customer may have the option to participate in a program
              with Syndica where customer gets to use alpha or beta versions of the Platform and/or
              related products, features or documentation, including a beta version of Syndica’s
              Platform during its initial rollout, if specified in an applicable Order Form
              (collectively, “Beta Products”). The Beta Products are not generally available and are
              provided “AS IS” and “AS AVAILABLE”, without warranty, indemnity, or support of any
              kind. Syndica may discontinue, modify or deprecate the Beta Products at any time in
              its sole discretion, and Syndica will have no liability or obligations for, and
              Customer will hold Syndica harmless from and against, any damage, loss or harm arising
              out of or relating to any use of the Beta Products.
            </p>
          </div>

          <div className="mt-4">
            <h5>3. RESTRICTIONS AND RESPONSIBILITIES</h5>
            <p>
              3.1. Restrictions. Customer will only use the Platform as expressly permitted herein
              and in the applicable Order Form and agrees that it will not (and will not allow any
              third party to), directly or indirectly: reverse engineer, decompile, disassemble or
              otherwise attempt to discover the source code, object code or underlying structure,
              ideas, know-how or algorithms relevant to the Platform; modify, translate, or create
              derivative works based on the Platform (except to the extent expressly permitted by
              Syndica in writing or authorized within the Platform); use the Platform for
              timesharing or service bureau purposes or otherwise for the benefit of any third
              party; use or access the Platform to develop a product or service that is competitive
              with the Platform or engage in competitive analysis or benchmarking; remove any
              proprietary notices or labels; or modify, adapt, hack, or attempt to probe, scan or
              test the vulnerability of, the Platform, or otherwise attempt to gain unauthorized
              access to the Platform or its related systems or networks. 3.2. Compliance. Customer
              represents, covenants, and warrants that Customer will use the Platform only in
              compliance with all applicable laws and regulations (including, without limitation,
              those relevant to privacy, intellectual property and the like). Although Syndica has
              no obligation to monitor Customer’s use of the Platform, Syndica may do so and may
              prohibit any use of the Platform it believes may be (or alleged to be) in violation of
              the foregoing or any other term of this Agreement. 3.3. Equipment. Customer shall be
              responsible for obtaining and maintaining any equipment and ancillary services needed
              to connect to, access or otherwise use the Platform, including, without limitation,
              modems, hardware, server, software, operating systems, networking, web servers and the
              like (collectively, “Equipment”). Customer shall also be responsible for maintaining
              the security of the Equipment, Customer account, passwords (including but not limited
              to administrative and user passwords) and files, and for all uses of Customer account
              or the Equipment with or without Customer’s knowledge or consent.
            </p>
          </div>

          <div className="mt-4">
            <h5>4. CONFIDENTIALITY; PROPRIETARY RIGHTS</h5>
            <p>
              4.1. Confidentiality. The Receiving Party agrees: (i) to take reasonable precautions
              to protect all Proprietary Information of the Disclosing Party, and (ii) not to use
              (except as permitted herein) or divulge to any third person (other than employees or
              contractors with a reasonable need to know who are bound by confidentiality
              obligations consistent with this Agreement) any such Proprietary Information of the
              Disclosing Party. The Disclosing Party agrees that the foregoing shall not apply with
              respect to any information that the Receiving Party can document (a) is or becomes
              generally available to the public through no fault of the Receiving Party, or (b) was
              in its possession or known by it without restriction prior to receipt from the
              Disclosing Party, or (c) was rightfully disclosed to it without restriction by a third
              party, or (d) was independently developed without use of any Proprietary Information
              of the Disclosing Party or (e) is required to be disclosed by law. 4.2. Data Security.
              Syndica will maintain a security program materially in accordance with industry
              standards that is designed to (i) ensure the security and integrity of Customer data
              uploaded to the Platform by Customer or collected by Syndica in the provision of the
              Platform (“Customer Data”); (ii) protect against threats or hazards to the security or
              integrity of Customer Data; and (iii) prevent unauthorized access to Customer Data. In
              furtherance of the foregoing, Syndica will maintain appropriate administrative,
              physical and technical safeguards to protect the security of Customer Data. Syndica’s
              security safeguards include measures for preventing access, use, modification or
              disclosure of Customer Data by Syndica personnel except (a) to provide and maintain
              the Platform and prevent or address service or technical problems, (b) as required by
              applicable law, or (c) as Customer expressly permits in writing or under this
              Agreement. Syndica will not materially diminish the protections provided in this
              Section during the term of this Agreement. If the parties determine that Syndica will
              be processing any Personal Information (as defined in the DPA referenced below)
              contained in Customer Data that is subject to the GDPR or CCPA (as defined in the
              DPA), on Customer’s behalf, in the provision of the Platform, the parties will execute
              Syndica’s standard Data Processing Addendum ("DPA"), and attach such DPA to this
              Agreement. 4.3. Proprietary Rights. Syndica shall own and retain all right, title and
              interest in and to (a) the Platform and all improvements, enhancements or
              modifications thereto, (b) any software, applications, inventions or other technology
              developed in connection with Platform, services or support, and (c) all intellectual
              property rights related to any of the foregoing. If Customer provides any suggestions,
              comments for enhancements or functionality or other feedback to Syndica with respect
              to the Platform or any of Syndica’s other products or services, Syndica will have the
              full, free and unencumbered right to use and otherwise fully exploit the same in
              connection with the Platform and its other products and services. 4.4. Platform
              Improvements; Aggregate Data and Marketing. Notwithstanding anything to the contrary,
              Syndica shall have the right to collect and analyze data and information relating to
              the use and performance of various aspects of the Platform and related technologies
              (including, without limitation, end-user request logs and other data related to
              platform usage), and Syndica will be free (during and after the term hereof) to (i)
              use such information and data to provide, improve and enhance the Platform and other
              Syndica offerings, and (ii) otherwise use and disclose such data solely in aggregate
              or other de-identified form in connection with its business. Further, Syndica shall
              have the right to use Customer’s name in a factual manner for marketing or promotional
              purposes on Syndica’s website and in other communication with existing or potential
              Syndica customers, and Customer hereby grants Syndica a license to display Customer’s
              name and logo on its website, in case studies, and other marketing or promotional
              materials. To decline Syndica this right, Customer must email Syndica (at the email
              address provided in the Platform) stating that Customer does not wish to grant Syndica
              this right. No rights or licenses are granted except as expressly set forth herein.
            </p>
          </div>

          <div className="mt-4">
            <h5>5. PAYMENT OF FEES</h5>
            <p>
              5.1. Fees. Customer will pay Syndica the then applicable subscription and other fees
              for the Platform and any other applicable services, as described in the relevant Order
              Form (or in the Platform itself, as applicable) in accordance with the terms therein
              (the “Fees”). All Fees are non-cancelable and non-refundable regardless of any early
              termination of this Agreement. If Customer’s use of the Platform exceeds any
              applicable limits set forth on the Order Form or otherwise requires the payment of
              additional fees (per the terms of this Agreement), Customer shall be billed for such
              usage and Customer agrees to pay the additional fees in the manner provided herein.
              Syndica reserves the right to change the Fees or applicable charges and to institute
              new charges and Fees at the end of the initial subscription term or thencurrent
              renewal term, upon forty five (45) days prior notice to Customer (which may be sent by
              email). If Customer believes that Syndica has billed Customer incorrectly, Customer
              must contact Syndica no later than 60 days after the closing date on the first billing
              statement in which the error or problem appeared, in order to receive an adjustment or
              credit. Inquiries should be directed to Syndica’s customer support department. 5.2.
              Payment Terms. Except as otherwise agreed in an applicable Order Form, payment of Fees
              will be due monthly in advance via credit card or other electronic payment method.
              Syndica may choose to bill through an invoice, in which case, full payment for
              invoices issued in any given month must be received by Syndica within seven (7) days
              after the date of the invoice. Unpaid or late Fees are subject to a finance charge of
              1.5% per month on any outstanding balance, or the maximum permitted by law, whichever
              is lower, plus all expenses of collection. Customer shall be responsible for all taxes
              associated with Platform other than U.S. taxes based on Syndica’s net income. Syndica
              reserves theright to suspend Customer’s access to the Platform if Customer fails to
              timely pay any Fees due to Syndica under this Agreement. Suspension shall not release
              Customer of its payment obligations under this Agreement.
            </p>
          </div>

          <div className="mt-4">
            <h5>6. TERM; TERMINATION</h5>
            <p>
              6.1. Term. Subject to earlier termination as provided below, this Agreement is for the
              initial subscription term as specified in the Order Form, and shall be automatically
              renewed for additional periods of the same duration as the initial subscription term
              (collectively, the “Term”), unless either party requests termination at least thirty
              (30) days prior to the end of the then-current term. 6.2. Termination . Customer may
              terminate this Agreement for convenience at any time upon written notice to Syndica,
              which notice may be provided via a subscription cancellation feature in the Platform;
              provided, however, that in accordance with Section 5.1 of this Agreement no refund or
              credit will be provided for Fees paid in advance. In addition to any other remedies it
              may have, Syndica may terminate this Agreement immediately upon written notice if
              Customer party materially breaches any of the terms or conditions of this Agreement.
              Syndica may also reasonably suspend Customer’s and/or any users’ access to or use of
              Platform at any time in its reasonable discretion if it possesses a good faith belief
              that Customer’s use of the Platform may be in violation of this Agreement or otherwise
              places Syndica (or its customers or other interests) at risk of harm, damage, loss or
              liability. Upon termination, Customer’s right to use the Platform shall immediately
              terminate, all outstanding Fees due for the Platform for the entire Term (regardless
              of any early termination) shall immediately become due and payable, Customer shall
              immediately cease use of and return (or at Syndica’s option destroy) all Platform
              software and related documentation in its possession or control, and each party shall
              return to the other all Proprietary Information. The terms of the following Sections
              shall survive expiration or termination of this Agreement: 3, 4, 5, 6.2, 8.2, 9, 10
              and 11.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
